export const ERROR_LOG = {
  DEFAULT_LEVEL: 'error',
  PAYLOAD_TYPE: 'error',
} as const;

export const API_ERROR_LOG = {
  DEFAULT_LEVEL: 'error',
  PAYLOAD_TYPE: 'apiError',
} as const;

export const NAVIGATE_LOG = {
  DEFAULT_LEVEL: 'info',
  PAYLOAD_TYPE: 'route',
} as const;
